/**
 * Extracts the tenant slug from the current hostname.
 *
 * Examples:
 *   acme.behvy.com    → "acme"
 *   behvy.com         → ""   (default B2C tenant)
 *   localhost          → ""   (local dev → default tenant)
 *   acme.localhost     → "acme"  (local dev B2B testing)
 */
export function getTenantSlug(): string {
  const host = window.location.hostname // e.g. "acme.behvy.com"
  const rootDomains = ['behvy.com', 'localhost']

  for (const root of rootDomains) {
    if (host === root) return '' // root domain = B2C
    if (host.endsWith(`.${root}`)) {
      return host.slice(0, host.length - root.length - 1) // remove ".behvy.com"
    }
  }

  // Fallback: treat as B2C
  return ''
}
